import {
  BookingRecord,
  Creator,
  Voucher,
  TicketOption,
  PaginatedResponse,
  DashboardStats,
  CustomerProfile,
  BlogPost,
  AppLicense,
} from "../types";
import {
  CREATOR_VOUCHERS,
  TICKET_OPTIONS,
  DEFAULT_CREATORS,
} from "../constants";

const BOOKING_KEY = "giz_all_bookings";
const CREATOR_KEY = "giz_creators";
const VOUCHER_KEY = "giz_vouchers";
const TICKET_KEY = "giz_tickets";
const BLOG_KEY = "giz_blog_posts";
const LICENSE_KEY = "giz_app_license";

// --- DATA SEEDING LOGIC ---
const seedDemoData = () => {
  const today = new Date().toISOString().split("T")[0];
  const yesterday = new Date(Date.now() - 86400000).toISOString().split("T")[0];
  const twoDaysAgo = new Date(Date.now() - 172800000)
    .toISOString()
    .split("T")[0];

  const demoBookings: BookingRecord[] = [
    {
      id: "demo_1",
      code: "GIZ-1001",
      customerName: "BUDI SANTOSO",
      email: "budi@gmail.com",
      phone: "08122334455",
      date: yesterday,
      category: "Personal",
      ticketId: "giz-only",
      ticketType: "GIZ Park (Glow Interactive Zoo)",
      pax: 2,
      totalPrice: 30000,
      status: "PAID",
      paymentMethod: "QRIS",
      bookingDate: new Date(Date.now() - 90000000).toISOString(),
    },
    {
      id: "demo_2",
      code: "GIZ-1002",
      customerName: "SITI AMINAH",
      email: "siti@yahoo.com",
      phone: "08561122334",
      date: today,
      category: "Personal",
      ticketId: "riw-only",
      ticketType: "RIW (Rabbit In Wonderland)",
      pax: 1,
      totalPrice: 18000,
      status: "PAID",
      paymentMethod: "QRIS",
      voucherCode: "GIZOCHI",
      affiliateName: "NICHAOCHI_SYER",
      bookingDate: new Date().toISOString(),
    },
    {
      id: "demo_3",
      code: "SCH-2001",
      customerName: "PIC SMA 1 SURABAYA (SMA 1)",
      email: "sma1sby@sch.id",
      phone: "031556677",
      date: today,
      category: "School",
      ticketId: "paket-riw-giz",
      ticketType: "Paket RIW + GIZ (Rombongan)",
      pax: 35,
      totalPrice: 892500,
      status: "COMPLETED",
      paymentMethod: "LOKET",
      bookingDate: new Date().toISOString(),
      checkInTime: new Date().toISOString(),
    },
    {
      id: "demo_4",
      code: "AGT-3001",
      customerName: "TRAVELINDO AGENT (TRAVELINDO)",
      email: "booking@travelindo.com",
      phone: "0811223344",
      date: today,
      category: "Agent",
      ticketId: "paket-lengkap-kbs",
      ticketType: "Paket RIW + GIZ + KBS (Rombongan)",
      pax: 40,
      totalPrice: 1530000,
      status: "PAID",
      paymentMethod: "QRIS",
      bookingDate: new Date().toISOString(),
    },
    {
      id: "demo_5",
      code: "GIZ-1003",
      customerName: "RAHMAT HIDAYAT",
      email: "rahmat@outlook.com",
      phone: "08213344556",
      date: yesterday,
      category: "Personal",
      ticketId: "paket-riw-giz",
      ticketType: "Paket RIW + GIZ",
      pax: 3,
      totalPrice: 81000,
      status: "PAID",
      paymentMethod: "QRIS",
      voucherCode: "GIZNISA",
      affiliateName: "ANISA OKTAVIANI",
      bookingDate: new Date(Date.now() - 100000000).toISOString(),
    },
    {
      id: "demo_6",
      code: "GIZ-1004",
      customerName: "DEWI LESTARI",
      email: "dewi.lestari@gmail.com",
      phone: "0877889900",
      date: today,
      category: "Personal",
      ticketId: "paket-lengkap-kbs",
      ticketType: "Paket RIW + GIZ + KBS",
      pax: 2,
      totalPrice: 81000,
      status: "PENDING",
      paymentMethod: "QRIS",
      voucherCode: "GIZMEIRIN",
      affiliateName: "IRENE NARDA",
      bookingDate: new Date().toISOString(),
    },
    {
      id: "demo_7",
      code: "GIZ-1005",
      customerName: "ANDI PRATAMA",
      email: "andi@gmail.com",
      phone: "0823232323",
      date: twoDaysAgo,
      category: "Personal",
      ticketId: "giz-only",
      ticketType: "GIZ Park (Glow Interactive Zoo)",
      pax: 1,
      totalPrice: 13500,
      status: "PAID",
      paymentMethod: "QRIS",
      voucherCode: "GIZCIPA",
      affiliateName: "FADYA PUTRI HARNINTYA",
      bookingDate: new Date(Date.now() - 200000000).toISOString(),
    },
    {
      id: "demo_8",
      code: "GIZ-1006",
      customerName: "EKO PRASETYO",
      email: "eko@dev.id",
      phone: "0899887766",
      date: yesterday,
      category: "Personal",
      ticketId: "riw-only",
      ticketType: "RIW (Rabbit In Wonderland)",
      pax: 4,
      totalPrice: 80000,
      status: "PAID",
      paymentMethod: "QRIS",
      bookingDate: new Date(Date.now() - 150000000).toISOString(),
    },
    {
      id: "demo_9",
      code: "SCH-2002",
      customerName: "SD MUHAMMADIYAH 4 (SD MUH 4)",
      email: "sdm4@sch.id",
      phone: "031445566",
      date: yesterday,
      category: "School",
      ticketId: "paket-riw-giz",
      ticketType: "Paket RIW + GIZ (Rombongan)",
      pax: 30,
      totalPrice: 765000,
      status: "COMPLETED",
      paymentMethod: "LOKET",
      bookingDate: new Date(Date.now() - 120000000).toISOString(),
      checkInTime: new Date(Date.now() - 110000000).toISOString(),
    },
    {
      id: "demo_10",
      code: "GIZ-1007",
      customerName: "LINA MARLINA",
      email: "lina@gmail.com",
      phone: "0812554433",
      date: today,
      category: "Personal",
      ticketId: "paket-riw-giz",
      ticketType: "Paket RIW + GIZ",
      pax: 2,
      totalPrice: 54000,
      status: "PAID",
      paymentMethod: "QRIS",
      voucherCode: "GIZOCHI",
      affiliateName: "NICHAOCHI_SYER",
      bookingDate: new Date().toISOString(),
    },
  ];

  localStorage.setItem(BOOKING_KEY, JSON.stringify(demoBookings));
};

export interface TransactionBreakdown {
  grossPrice: number;
  voucherDiscount: number;
  bulkDiscount: number;
  customerPaid: number;
  serviceFee: number;
  affiliateFee: number;
  netIncome: number;
}

export const getTransactionBreakdown = (
  booking: BookingRecord
): TransactionBreakdown => {
  if (!booking)
    return {
      grossPrice: 0,
      voucherDiscount: 0,
      bulkDiscount: 0,
      customerPaid: 0,
      serviceFee: 0,
      affiliateFee: 0,
      netIncome: 0,
    };

  // Jika booking sudah memiliki data dari database (API), gunakan langsung
  if (booking.grossPrice !== undefined && booking.netIncome !== undefined) {
    return {
      grossPrice: booking.grossPrice || 0,
      voucherDiscount: booking.voucherDiscount || 0,
      bulkDiscount: booking.bulkDiscount || 0,
      customerPaid: booking.totalPrice || 0,
      serviceFee: booking.serviceFee || 0,
      affiliateFee: booking.affiliateFee || 0,
      netIncome: booking.netIncome || 0,
    };
  }

  // Fallback untuk data lama (localStorage/demo)
  const safePax = Number(booking.pax) || 0;
  const safeTotal = Number(booking.totalPrice) || 0;
  const safeDate = booking.bookingDate || new Date().toISOString();

  const tickets = getTickets();
  const ticket = tickets.find((t) => t.id === booking.ticketId);
  const unitPrice = ticket
    ? ticket.price
    : booking.ticketType.toLowerCase().includes("combo")
    ? 35000
    : 20000;
  const grossPrice = unitPrice * safePax;

  let voucherDiscount = 0;
  let bulkDiscount = 0;
  let affiliateFee = 0;

  const totalReduction = Math.max(0, grossPrice - safeTotal);
  const isBulk = booking.category === "School" || booking.category === "Agent";

  if (isBulk) {
    // Rombongan: hanya bulk discount, tidak ada voucher
    bulkDiscount = totalReduction;
    voucherDiscount = 0;
    affiliateFee = 0;
  } else {
    // Personal: hanya voucher discount jika ada
    voucherDiscount = totalReduction;
    bulkDiscount = 0;

    if (booking.voucherCode) {
      // Komisi mitra tetap 6% dari total yang dibayar customer
      affiliateFee = Math.floor(safeTotal * 0.06);
    }
  }

  const serviceFee = calculateServiceFee(safeDate, safeTotal);
  const netIncome = Math.max(0, safeTotal - serviceFee - affiliateFee);

  return {
    grossPrice,
    voucherDiscount,
    bulkDiscount,
    customerPaid: safeTotal,
    serviceFee,
    affiliateFee,
    netIncome,
  };
};

export const getLicense = (): AppLicense => {
  const data = localStorage.getItem(LICENSE_KEY);
  if (!data) {
    const mock: AppLicense = {
      id: "LIC-2025-001",
      clientName: "GIZ & RIW Management",
      startDate: new Date().toISOString(),
      endDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString(),
      status: "Active",
      feePerTransaction: 0.014,
      freePeriodMonths: 3,
    };
    localStorage.setItem(LICENSE_KEY, JSON.stringify(mock));
    return mock;
  }
  return JSON.parse(data);
};

export const updateLicenseStart = (monthsOffset: number) => {
  const current = getLicense();
  const newStart = new Date();
  newStart.setMonth(newStart.getMonth() - monthsOffset);
  const updated = { ...current, startDate: newStart.toISOString() };
  localStorage.setItem(LICENSE_KEY, JSON.stringify(updated));
  return updated;
};

export const calculateServiceFee = (
  bookingDate: string,
  amount: number
): number => {
  const license = getLicense();
  const start = new Date(license.startDate);
  const booking = new Date(bookingDate || new Date().toISOString());
  const freePeriodEnd = new Date(start);
  freePeriodEnd.setMonth(
    freePeriodEnd.getMonth() + (license.freePeriodMonths || 0)
  );

  if (booking < freePeriodEnd) return 0;
  return Math.round(Number(amount || 0) * (license.feePerTransaction || 0.014));
};

export const getAllBookings = (): BookingRecord[] => {
  const data = localStorage.getItem(BOOKING_KEY);
  if (!data) {
    seedDemoData();
    const seeded = localStorage.getItem(BOOKING_KEY);
    return seeded ? JSON.parse(seeded) : [];
  }
  return JSON.parse(data);
};

export const getLicenseStats = () => {
  const license = getLicense();
  const all = getAllBookings();
  const paid = all.filter(
    (b) => b.status === "PAID" || b.status === "COMPLETED"
  );
  let totalFee = 0;
  let freeTxCount = 0;
  let billableTxCount = 0;

  paid.forEach((b) => {
    const fee = calculateServiceFee(b.bookingDate, b.totalPrice);
    if (fee === 0) freeTxCount++;
    else {
      billableTxCount++;
      totalFee += fee;
    }
  });

  return {
    license,
    totalFee,
    freeTxCount,
    billableTxCount,
    totalTx: paid.length,
  };
};

export const createNewBooking = (
  data: Partial<BookingRecord>
): BookingRecord => {
  const all = getAllBookings();
  const id = `giz_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
  const prefix =
    data.category === "School"
      ? "SCH"
      : data.category === "Agent"
      ? "AGT"
      : "GIZ";
  const code =
    data.code || `${prefix}-${Math.floor(1000 + Math.random() * 8999)}`;

  const tickets = getTickets();
  const ticket = tickets.find(
    (t) => t.id === data.ticketId || t.title === data.ticketType
  );

  const newRecord: BookingRecord = {
    id,
    code,
    customerName: (data.customerName || "").toUpperCase(),
    email: data.email || "",
    phone: data.phone || "",
    date: data.date || new Date().toISOString().split("T")[0],
    category: data.category || "Personal",
    ticketId: ticket?.id || data.ticketId || "",
    ticketType: ticket?.title || data.ticketType || "",
    pax: Number(data.pax || 1),
    totalPrice: Number(data.totalPrice || 0),
    status: data.status || "PENDING",
    paymentMethod: data.paymentMethod || "QRIS",
    bookingDate: data.bookingDate || new Date().toISOString(),
    voucherCode: data.voucherCode,
    affiliateName: data.affiliateName,
  };
  localStorage.setItem(BOOKING_KEY, JSON.stringify([newRecord, ...all]));
  localStorage.setItem("giz_last_booking_code", newRecord.code);
  return newRecord;
};

export const getBookingsPaginated = (
  page: number,
  limit: number,
  search: string,
  status: string,
  date: string,
  email: string = ""
): Promise<PaginatedResponse<BookingRecord>> => {
  return new Promise((res) => {
    let all = getAllBookings();
    if (search) {
      const q = search.toLowerCase();
      all = all.filter(
        (b) =>
          (b.code || "").toLowerCase().includes(q) ||
          (b.customerName || "").toLowerCase().includes(q)
      );
    }
    if (status !== "ALL") all = all.filter((b) => b.status === status);
    if (date) all = all.filter((b) => b.date === date);
    if (email)
      all = all.filter(
        (b) => (b.email || "").toLowerCase() === email.toLowerCase()
      );
    const data = all.slice((page - 1) * limit, page * limit);
    const totalPages = Math.ceil(all.length / limit) || 1;
    res({
      data,
      meta: {
        total: all.length,
        perPage: limit,
        currentPage: page,
        lastPage: totalPages,
        firstPage: 1,
      },
    });
  });
};

export const getCustomersPaginated = (
  page: number,
  limit: number,
  search: string
): Promise<PaginatedResponse<CustomerProfile>> => {
  return new Promise((res) => {
    const all = getAllBookings();
    const map = new Map<string, CustomerProfile>();
    all.forEach((b) => {
      if (!b.email) return;
      const ex = map.get(b.email);
      if (ex) {
        ex.totalVisits++;
        ex.totalSpend += Number(b.totalPrice || 0);
      } else {
        map.set(b.email, {
          id: b.email,
          email: b.email,
          name: b.customerName,
          phone: b.phone,
          type: b.category,
          totalVisits: 1,
          totalSpend: Number(b.totalPrice || 0),
          lastVisit: b.date,
        });
      }
    });
    let list = Array.from(map.values());
    if (search)
      list = list.filter(
        (c) =>
          (c.name || "").toLowerCase().includes(search.toLowerCase()) ||
          (c.email || "").toLowerCase().includes(search.toLowerCase())
      );
    const totalPages = Math.ceil(list.length / limit) || 1;
    res({
      data: list.slice((page - 1) * limit, page * limit),
      meta: {
        total: list.length,
        perPage: limit,
        currentPage: page,
        lastPage: totalPages,
        firstPage: 1,
      },
    });
  });
};

export const getDashboardStats = (): Promise<DashboardStats> => {
  return new Promise((resolve) => {
    const all = getAllBookings();
    const paid = all.filter(
      (b) => b.status === "PAID" || b.status === "COMPLETED"
    );
    let netIncomeTotal = 0;
    paid.forEach((b) => {
      netIncomeTotal += getTransactionBreakdown(b).netIncome;
    });
    resolve({
      totalIncome: netIncomeTotal,
      totalPax: all
        .filter((b) => b.status !== "CANCELLED")
        .reduce((acc, curr) => acc + (Number(curr.pax) || 0), 0),
      totalBookings: all.length,
      completedOrders: all.filter((b) => b.status === "COMPLETED").length,
      paidOrders: paid.length,
      recentBookings: all.slice(0, 5),
    });
  });
};

export const getTodayOverviewStats = () => {
  const all = getAllBookings();
  const today = new Date().toISOString().split("T")[0];
  const expectedToday = all.filter(
    (b) => b.date === today && b.status !== "CANCELLED"
  );
  const checkedInToday = all.filter(
    (b) => b.checkInTime && b.checkInTime.startsWith(today)
  );
  const totalExpectedPax = expectedToday.reduce(
    (sum, b) => sum + (Number(b.pax) || 0),
    0
  );
  const totalCheckedInPax = checkedInToday.reduce(
    (sum, b) => sum + (Number(b.pax) || 0),
    0
  );
  return {
    totalExpectedPax,
    totalCheckedInPax,
    remainingPax: Math.max(0, totalExpectedPax - totalCheckedInPax),
    percent:
      totalExpectedPax > 0
        ? Math.round((totalCheckedInPax / totalExpectedPax) * 100)
        : 0,
    recentCheckIns: checkedInToday.slice(0, 10),
  };
};

export const updateBookingStatus = (
  id: string,
  status: BookingRecord["status"]
) => {
  const current = getAllBookings();
  const updated = current.map((b) =>
    b.id === id
      ? {
          ...b,
          status,
          checkInTime:
            status === "COMPLETED" ? new Date().toISOString() : b.checkInTime,
        }
      : b
  );
  localStorage.setItem(BOOKING_KEY, JSON.stringify(updated));
  return updated;
};

export const deleteBooking = (id: string) => {
  const current = getAllBookings();
  const updated = current.filter((b) => b.id !== id);
  localStorage.setItem(BOOKING_KEY, JSON.stringify(updated));
  return updated;
};

export const getVouchers = (): Voucher[] => {
  const data = localStorage.getItem(VOUCHER_KEY);
  return data ? JSON.parse(data) : CREATOR_VOUCHERS;
};

export const getCreators = (): Creator[] => {
  const data = localStorage.getItem(CREATOR_KEY);
  return data ? JSON.parse(data) : DEFAULT_CREATORS;
};

export const getTickets = (): TicketOption[] => {
  const data = localStorage.getItem(TICKET_KEY);
  return data ? JSON.parse(data) : TICKET_OPTIONS;
};

export const validateTicketForEntry = (code: string) => {
  const all = getAllBookings();
  const b = all.find((x) => x.code.toUpperCase() === code.toUpperCase());
  if (!b) return { success: false, message: "Tiket Tidak Ditemukan" };
  if (b.status === "PENDING")
    return { success: false, message: "Tiket Belum Dibayar", booking: b };
  if (b.status === "COMPLETED")
    return {
      success: false,
      message: "Tiket Sudah Check-in Sebelumnya",
      booking: b,
    };
  if (b.status === "CANCELLED")
    return { success: false, message: "Tiket Dibatalkan", booking: b };
  updateBookingStatus(b.id, "COMPLETED");
  return {
    success: true,
    message: "Check-in Berhasil!",
    booking: { ...b, status: "COMPLETED" as const },
  };
};

export const saveTicket = (t: TicketOption) => {
  const c = getTickets();
  const idx = c.findIndex((x) => x.id === t.id);
  const u = idx >= 0 ? c.map((x) => (x.id === t.id ? t : x)) : [...c, t];
  localStorage.setItem(TICKET_KEY, JSON.stringify(u));
  return u;
};

export const deleteTicket = (id: string) => {
  const u = getTickets().filter((t) => t.id !== id);
  localStorage.setItem(TICKET_KEY, JSON.stringify(u));
  return u;
};

export const findCreatorBySearch = (q: string) => {
  const term = q.toLowerCase().trim();
  return getCreators().find(
    (c) =>
      (c.name || "").toLowerCase() === term ||
      (c.whatsapp || "").includes(term) ||
      c.id === q
  );
};

export const saveCreator = (c: Creator) => {
  const current = getCreators();
  const idx = current.findIndex((x) => x.id === c.id);
  const u =
    idx >= 0 ? current.map((x) => (x.id === c.id ? c : x)) : [...current, c];
  localStorage.setItem(CREATOR_KEY, JSON.stringify(u));
  return u;
};

export const deleteCreator = (id: string) => {
  const u = getCreators().filter((c) => c.id !== id);
  localStorage.setItem(CREATOR_KEY, JSON.stringify(u));
  return u;
};
export const saveVoucher = (v: Voucher) => {
  const current = getVouchers();
  const idx = current.findIndex((x) => x.id === v.id);
  const u =
    idx >= 0 ? current.map((x) => (x.id === v.id ? v : x)) : [...current, v];
  localStorage.setItem(VOUCHER_KEY, JSON.stringify(u));
  return u;
};
export const deleteVoucher = (id: string) => {
  const u = getVouchers().filter((v) => v.id !== id);
  localStorage.setItem(VOUCHER_KEY, JSON.stringify(u));
  return u;
};
export const findBookingByCodeOrEmail = (q: string) =>
  getAllBookings().find(
    (b) =>
      (b.code || "").toLowerCase() === q.toLowerCase() ||
      (b.email && b.email.toLowerCase() === q.toLowerCase())
  );

export const getBlogPosts = (): BlogPost[] => {
  const d = localStorage.getItem(BLOG_KEY);
  return d ? JSON.parse(d) : [];
};
export const saveBlogPost = (p: BlogPost) => {
  const curr = getBlogPosts();
  const idx = curr.findIndex((x) => x.id === p.id);
  const upd =
    idx >= 0 ? curr.map((x) => (x.id === p.id ? p : x)) : [p, ...curr];
  localStorage.setItem(BLOG_KEY, JSON.stringify(upd));
  return upd;
};
export const deleteBlogPost = (id: string) => {
  const upd = getBlogPosts().filter((p) => p.id !== id);
  localStorage.setItem(BLOG_KEY, JSON.stringify(upd));
  return upd;
};
